import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { selectProgramSubscriptionsListItems } from "../../../../../redux/program-subscriptions/selector";
import { programSubscriptions } from "../../../../../redux/program-subscriptions/action"

export const SubscriptionComponent = ({ id }: any) => {

 const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const ProgramSubscriptionsItems = useSelector(selectProgramSubscriptionsListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {field: 'OwnerName', headerName: 'Owner Name' },
        {field: 'OwnerType', headerName: 'Owner Type' },
 


    ]);
  }


  const fetchProgramSubscriptions = () => {
    dispatch(programSubscriptions.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-program-subscriptions/list`,
      entity: 'programSubscriptions',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",

         Filters: [
          {
            FieldName: 'ONEProgramPolicyId',
            FilterOperatorId: 1,
            FieldValue: id,
            FieldType: 'number'
          }
        ]
      }
    }))
  }

 

  useEffect(() => {
    createColumnDefs()
    fetchProgramSubscriptions()
  }, [pageData, pageSize])


  return (
    <>
      {ProgramSubscriptionsItems?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={ProgramSubscriptionsItems?.result?.items} setPageData={setPageData}
          setPageSize={setPageSize} paginationData={ProgramSubscriptionsItems?.result?.pagination}
          
        />
      }
    </>
  );
  
}
export default SubscriptionComponent;
